export default __webpack_public_path__ + "static/media/RTCC.b06f8b19.png";